import { Link } from 'react-router-dom'

import styles from './WelcomeHero.module.css'

type WelcomeHeroProps = {
  appName: string
}

/**
 * Flyer-inspired first viewport: brand-led title, one line of support, CTAs, full-bleed market art.
 */
export function WelcomeHero({ appName }: WelcomeHeroProps) {
  const brand = appName.replace(/\s+Market.*/i, '').trim() || 'Oikos'

  return (
    <section className={styles.hero} aria-labelledby="welcome-heading">
      <div className={styles.visual} aria-hidden="true">
        <img
          className={styles.flyer}
          src="/brand/market-flyer.jpg"
          alt=""
        />
        <div className={styles.scrim} />
      </div>

      <div className={styles.copy}>
        <div className={styles.bunting} aria-hidden="true">
          <span /><span /><span /><span /><span /><span /><span />
        </div>
        <p className={styles.brandLine}>
          <span className={styles.brandGreen}>{brand.toUpperCase()}</span>
          <span className={styles.brandOrange}> MARKET DAY</span>
        </p>
        <h1 id="welcome-heading" className={styles.headline}>
          Come shop, eat, relax
        </h1>
        <p className={styles.support}>
          Local &amp; homemade vibes at Oikos Private School, 0 Pilgrim Street, Barberton — every month.
        </p>
        <div className={styles.actions}>
          <Link className={styles.primaryCta} to="/signup">
            All vendors welcome
          </Link>
          <Link className={styles.secondaryCta} to="/login">
            Sign in
          </Link>
        </div>
      </div>
    </section>
  )
}
